import { React, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
  Button,
  Input,
} from "reactstrap";
import Modal from "react-modal";
import {
  // rejectRequest,
  approveRejectedRequest,
} from "../../../actions/request";
import { CustomDialog } from "../../Utils/utils";
// import { AiFillDownCircle, AiFillUpCircle } from 'react-icons/ai';
import SearchResults from "../../Utils/SearchResults";
import { Loading } from "../../../loader/Loading";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "85%",
    border: "8px solid #9ba5ad",
    maxHeight: "100vh",
    overflowY: "auto",
  },
};

function RejectedDetails(props) {
  const dispatch = useDispatch();
  const [currState, setCurrState] = useState({
    modal: false,
    commentsval: null,
    btnName: "",
    collapse: false,
  });
  //look into this later
  // const myRef = useRef();
  //   this.togglePanel = this.togglePanel.bind(this);

  const { rejectedInfo, success } = useSelector((state) => state?.requests);
  const error = useSelector((state) => state?.error?.error_obj);
  const isLoading = useSelector((state) => state?.fetch?.isLoading);

  // const clearRejectedInfoFn = () =>
  //   dispatch({ type: "SET_REJECTED_INFO", data: { rejectedInfo: undefined } });
  // rejectRequest: (username, details, comments) => {
  // 	dispatch(rejectRequest(username, details, comments));
  // },
  const resetErrorFn = () => dispatch({ type: "RESET_ERROR" });
  const approveRejectedRequestFn = (...props) => {
    dispatch(approveRejectedRequest(...props));
  };

  useEffect(() => {
    // if (error && error.message === "User with given email already exists") {
    //   myRef.current.scrollIntoView();
    // }
    return () => {
      dispatch({
        type: "SET_REJECTED_INFO",
        data: { rejectedInfo: undefined },
      });
    };
  }, [dispatch]);

  useEffect(() => {
    return () =>
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  }, []);

  const requestAction = (action) => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        commentsval: null,
        btnName: action,
      };
    });
    toggle();
  };

  const modalButtonClick = (btnName) => {
    let distAccount =
      rejectedInfo &&
      rejectedInfo.details &&
      rejectedInfo.details.custom_distributoraccount &&
      rejectedInfo.details.custom_distributoraccount.join(",");
    let approveData = rejectedInfo.details;
    approveData["distributorAccount"] = distAccount;

    if (btnName === "Approve") {
      approveRejectedRequestFn(
        approveData,
        rejectedInfo.rejected_date
        // this.attributeName,
        // this.attributeValue
      );
      toggle();
      // this.props.MainToggle();
    } else {
      toggle();
    }
  };

  const toggle = () => {
    setCurrState((prevState) => {
      return {
        ...prevState,
        modal: !currState.modal,
      };
    });
  };

  // const togglePanel = (e) => {
  //   setCurrState({
  //     ...currState,
  //     collapse: !currState?.collapse,
  //   });
  // };

  const columns = [
    {
      Header: "Reviewed By",
      accessor: "rejected_by_name",
    },
    {
      Header: `Reviewer's Email`,
      accessor: "rejected_by_email",
    },
    {
      Header: "Rejection Reason",
      accessor: "rejected_comments",
    },
    {
      Header: "Rejection Date",
      accessor: "rejected_date",
    },
  ];

  const {
    address,
    custom_Groups: role,
    custom_city: city,
    custom_company: company,
    custom_country: country,
    custom_state: state,
    custom_telephone: telephone,
    custom_zip: zip,
    email,
    family_name: lastName,
    given_name: firstName,
    phone_number: phoneNumber,
  } = rejectedInfo.details;

  const {
    rejected_comments: rejComments,
    rejected_by_name: rejName,
    rejected_by_email: rejEmail,
    rejected_date: rejDate,
  } = rejectedInfo;

  const rejectedData = [
    {
      rejected_comments: rejComments,
      rejected_by_name: rejName,
      rejected_by_email: rejEmail,
      rejected_date: rejDate,
    },
  ];
  if (success) props.MainToggle();

  // let productTypeData = product_type && product_type.replace(/,/g, "\n");
  // let distributorData =
  //   custom_distributoraccount && custom_distributoraccount.join("\n");
  // let companyBuyData = distributorData ? `${distributorData}` : "";

  let headerText = `Approve request`;
  let messageText = `Do you want to Approve ?`;
  let confirmButton = "OK";

  let emailExists =
    error && error.message === "User with given email already exists";

  return (
    <div>
      {isLoading && !error && <Loading />}
      <Modal
        isOpen={props.MainModal}
        style={customStyles}
        ariaHideApp={false}
        onRequestClose={props.MainToggle}
      >
        <Container fluid>
          {rejectedInfo && (
            <Form>
              <div
                style={{ float: "Right", cursor: "pointer" }}
                onClick={(e) => props.MainToggle()}
              >
                <b>X</b>
              </div>
              {/* <h5 ref={myRef}> */}
              <h5>
                Rejection Details
                {emailExists && (
                  <span
                    style={{
                      textAlign: "center",
                      color: "Red",
                      fontSize: "17px",
                      marginLeft: "4%",
                    }}
                  >
                    {error.message}
                  </span>
                )}
              </h5>
              <hr />
              <CustomDialog
                modal={currState?.modal}
                header={headerText}
                message={messageText}
                toggle={toggle}
                button1fun={() => modalButtonClick(currState?.btnName)}
                confirmButton={confirmButton}
              />
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="email" id="email" className="label">
                      Email ID:
                    </Label>
                    <Label for="emailVal" id="emailVal">
                      {email}
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="company" id="company" className="label">
                      Company:
                    </Label>
                    <Label for="companyVal" id="companyVal">
                      {company}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="firstName" id="firstName" className="label">
                      First Name:
                    </Label>
                    <Label for="firstNameVal" id="firstNameVal">
                      {firstName}
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="lastName" id="lastName" className="label">
                      Last Name:
                    </Label>
                    <Label for="lastNameVal" id="lastNameVal">
                      {lastName}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label
                      for="mobileNumber"
                      id="mobileNumber"
                      className="label"
                    >
                      Mobile Number:
                    </Label>
                    <Label for="mobileNumberVal" id="mobilrNumberVal">
                      {phoneNumber}
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="phoneNumber" id="phoneNumber" className="label">
                      Company Phone Number:
                    </Label>
                    <Label for="phoneNumberVal" id="phoneNumberVal">
                      {telephone}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="City" id="City" className="label">
                      City:
                    </Label>
                    <Label for="CityVal" id="CityVal">
                      {city}
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="State" id="State" className="label">
                      State:
                    </Label>
                    <Label for="StateVal" id="StateVal">
                      {state}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="Zip" id="Zip" className="label">
                      Zip/Postal Code:
                    </Label>
                    <Label for="ZipVal" id="ZipVal">
                      {zip}
                    </Label>
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="Country" id="Country" className="label">
                      Country:
                    </Label>
                    <Label for="CountryVal" id="CountryVal">
                      {country}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="Address" id="Address" className="label">
                      Address:
                    </Label>
                    <Input type="textarea" disabled value={address} />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup>
                    <Label for="accessrole" id="accessrole" className="label">
                      Access Role(s):
                    </Label>
                    <Input type="textarea" disabled value={role} />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                {rejectedInfo && (
                  <Col sm={12}>
                    <FormGroup>
                      <div>
                        <span style={{ fontWeight: "bold" }}>
                          Rejection History
                        </span>
                        {/* <span
																onClick={(e) => this.togglePanel(e)}
																className='rejectedDetailsHeaderCollapse'>
																{!this.state.collapse ? (
																	<AiFillUpCircle />
																) : (
																	<AiFillDownCircle />
																)}
															</span>
															 {this.state.collapse ? (  */}
                        <div className="rejectedDetailsContent">
                          <SearchResults
                            columns={columns}
                            data={rejectedData}
                            paginationNotRequired={true}
                          />
                        </div>
                        {/* ) : null} */}
                      </div>
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row>
                <Col sm={6}>
                  <FormGroup style={{ display: "flex" }}>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        resetErrorFn();
                        requestAction("Approve");
                      }}
                      style={{
                        display: "center",
                        marginRight: "5px",
                        width: "165px",
                      }}
                    >
                      Approve
                    </Button>
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        props.MainToggle();
                      }}
                      style={{
                        width: "165px",
                      }}
                    >
                      Cancel
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          )}
        </Container>
      </Modal>
    </div>
  );
}

export default RejectedDetails;
